// echarts可视化专属工具方法文件
import moment from 'moment';
import { merge, uniqBy } from 'lodash-es';
import * as echarts from 'echarts';
import { ECHARTSCOLOR } from './echartsConst';
import DataBrainIcon from '@/pages/intelligence/assets/svg/dataSource/databrain-blue-bg.svg';
import svgAppannie from '@/pages/intelligence/assets/svg/dataSource/appnnie.svg';
import svgAppannieWhiteBg from '@/pages/intelligence/assets/svg/dataSource/app-annie.svg';
import svgSensortower from '@/pages/intelligence/assets/svg/dataSource/sensor-tower.svg';
import svgAppstore from '@/pages/intelligence/assets/svg/dataSource/appstore.svg';
import svgGoogleplay from '@/pages/intelligence/assets/svg/dataSource/googleplay.svg';
import svgSteam from '@/pages/intelligence/assets/svg/dataSource/steam.svg';
import svgXbox from '@/pages/intelligence/assets/svg/dataSource/xbox.svg';
import svgPlaystation from '@/pages/intelligence/assets/svg/dataSource/playstation.svg';
import mscience from '@/pages/intelligence/assets/svg/dataSource/mscience-bg.svg';
import npd from '@/pages/intelligence/assets/svg/dataSource/npd.svg';
import gsd from '@/pages/intelligence/assets/svg/dataSource/gsd-icon.svg';
import {
  isEmpty,
  isObject,
  mathFormat,
  showTimeByDateType,
  newMathFormat,
} from '@/pages/intelligence/utils/commonUtils';
import { getIfPercentage } from '@/pages/intelligence/utils/common';
import type {
  IEChartDataEntity,
  IEChartSeriesOption,
} from '@intelligence/types/echart';

export function groupBy(array: any = [], f: any) {
  const groups: any = {};
  array.forEach((o: any) => {
    const group: any = JSON.stringify(f(o));
    groups[group] = groups[group] || [];
    groups[group].push(o);
  });
  return Object.keys(groups).map((group) => groups[group]);
}

/**
 *  根据名称去重
 * @param arr
 * @returns
 */
export function unique(arr = [], cell: any) {
  const map = new Map();
  for (const item of arr) {
    if (!map.has(item[cell])) {
      map.set(item[cell], item);
    }
  }
  return [...map.values()];
}

// home折线图排序
export const sortLineTooltipValue = (params: any, inverse = false) => {
  const valueArr: any[] = [];
  const undeArr: any[] = [];
  params?.forEach((item: any) => {
    if (item?.value) {
      valueArr.push(item);
    } else {
      undeArr.push(item);
    }
  });
  const sortArr = valueArr.sort((a, b) =>
    inverse ? a?.value - b?.value : b?.value - a?.value,
  );
  return [...sortArr, ...undeArr];
};

/**
 * 线型图数据处理
 * @param echartsData 原始数据
 * @param trans 是否转换
 * @param cell  value值
 * @returns  处理后数据
 */
export function echartsData({
  echartsData,
  cell,
  isShowRangeDayMonth = false,
  dateType = 'day',
  sortXAxis = false,
}: {
  echartsData: any;
  cell: any;
  isShowRangeDayMonth: boolean;
  dateType?: string;
  sortXAxis?: boolean;
}) {
  // 根据时间进行排序
  // orderByTime(echartsData)

  // 根据时间分组
  const group = groupBy(echartsData, (item: any) => item.time);

  // console.log('group123123',group);

  // 名称去重
  const legend = unique(echartsData, 'rank');

  // 时间去重
  let timeData = unique(echartsData, 'time');

  // TOP_CHARTS_TYPES.COMPARE_MOBILE_ACTIVEREVDOWN All of time 数据需要排序避免显示错位
  if (sortXAxis) {
    timeData = timeData?.sort(
      (a, b) => moment(a?.time).valueOf() - moment(b?.time).valueOf(),
    );
  }

  // console.log('timeData',timeData);

  const dataSerie: any = [];
  const dataX: any = [];
  const dataL: any = [];

  const dataBarSerie: any = [];
  // 某个游戏是否有补齐数据
  const IsPredict = timeData.some((item) => item?.b_predict);
  legend.map((L, index) => {
    let name: any;
    let cover: any;
    // 正常数据数组
    const a: any = [];
    // 补齐数据数组
    const b: any = [];
    let countA: any = 0;
    let countB: any = 0;
    timeData.map((time) => {
      group.map((item, index: number) => {
        // item：某天
        item.map((value: any, i: number) => {
          // value：当天的游戏
          if (time.time == value.time && L.rank == value.rank) {
            if (!value?.b_predict) {
              // 正常数据
              countA = value[cell];
              countB = '-';
            } else {
              // 补齐数据
              // 前一天或者后一天都是补齐数据，countA 才填 '-'
              // 两条线才能连上
              if (group[index - 1] && group[index + 1]) {
                // 当前不是第一天或者最后一天
                if (
                  group[index - 1][i]?.b_predict &&
                  group[index + 1][i]?.b_predict
                ) {
                  countA = '-';
                } else {
                  countA = value[cell];
                }
              } else if (!group[index - 1] && group[index + 1]) {
                // 当前是第一天
                if (group[index + 1][i]?.b_predict) {
                  countA = '-';
                } else {
                  countA = value[cell];
                }
              } else if (!group[index + 1] && group[index - 1]) {
                // 当前是最后一天
                if (group[index - 1][i]?.b_predict) {
                  countA = '-';
                } else {
                  countA = value[cell];
                }
              }
              countB = value[cell];
            }
          }
        });
      });
      // console.log('countAcountAcountA', countA)
      a.push(countA);
      b.push(countB);
    });
    // console.log('LLLLLLLLLLLLLLLLLLLLLL', L)
    // console.log('aaa', a)
    name = L.rank;
    cover = L.cover;
    const data: any = {
      name,
      type: 'line',
      data: a,
      showSymbol: false,
      symbolSize: 8,
      symbol: 'circle',
      cover,
      IsPredictData: false, // 正常数据，不用补齐数据的颜色
      // IsPredictData: !IsPredict // 标识是否用补齐数据的颜色
    };

    // console.log('datadatadatadatadata', data)

    const dataBar: any = {
      showSymbol: false,
      name,
      type: 'bar',
      data: a,
      barMaxWidth: 30, // 最大宽度
    };

    dataBarSerie.push(dataBar);
    dataSerie.push(data);

    if (IsPredict) {
      // 某个游戏有补齐数据
      const data: any = {
        name,
        type: 'line',
        data: b,
        showSymbol: false,
        symbolSize: 8,
        symbol: 'circle',
        cover,
        IsPredictData: IsPredict, // 标识是否用补齐数据的颜色
      };

      dataSerie.push(data);
    }
  });

  // 图例
  legend.map((v, _) => {
    dataL.push(v.rank);
  });

  // 时间
  timeData.map((v, _) => {
    dataX.push(
      isShowRangeDayMonth ? v.time : showTimeByDateType(v.time, dateType),
    );
  });

  return {
    dataL,
    dataX,
    dataSerie,
    dataBarSerie,
    timeData,
  };
}

export const getIcon = (name: string) => {
  if (typeof name !== 'string' || !name) return undefined;
  const lowerName = name.toLowerCase();

  switch (true) {
    case lowerName === 'appannie-white-bg':
      return svgAppannieWhiteBg;
    case lowerName.includes('databrain'):
      return DataBrainIcon;
    case lowerName.includes('databarin'):
      return DataBrainIcon;
    case lowerName.includes('ogdb'):
      return DataBrainIcon;
    case lowerName.includes('annie'):
    case lowerName.includes('appannie'):
    case lowerName.includes('data.ai'):
      return svgAppannie;
    case lowerName.includes('tower'):
    case lowerName.includes('sensortower'):
      return svgSensortower;
    case lowerName.includes('appstore'):
      return svgAppstore;
    case lowerName.includes('googleplay'):
      return svgGoogleplay;
    case lowerName.includes('pcu'):
    case lowerName.includes('steam'):
      return svgSteam;
    case lowerName.includes('xbox'):
      return svgXbox;
    case lowerName.includes('playstation'):
      return svgPlaystation;
    case lowerName.includes('mscience'):
      return mscience;
    case lowerName.includes('npd'):
      return npd;
    case lowerName.includes('gsd'):
      return gsd;
    default:
      return undefined;
  }
};

// 排序
export const moveZero = (arr: any[]) => {
  const sortArr = arr.sort((a, b) => b.data - a.data);
  return [...sortArr];
};

export const getPieWidth = (sources: string[]): any => {
  if (!Array.isArray(sources) || sources.length < 3) return '50%';
  return '33.3333%';
};

export const getPieAndPieTitlePosition = (
  sources: string[],
  serieIndex: number,
): any => {
  let left: number | string = 'center';
  let titleLeft: number | string = 'center';
  if (!Array.isArray(sources)) {
    left = 'center';
    titleLeft = 'center';
  } else if (sources.length === 1) {
    left = 'center';
    titleLeft = 'center';
  } else if (sources.length === 2) {
    left = serieIndex === 0 ? '0' : '50%';
    titleLeft = serieIndex === 0 ? '24.6666%' : '74.6666%';
  } else if (sources.length === 3) {
    left = serieIndex === 0 ? 0 : serieIndex === 1 ? '33.3333%' : '66.6667%';
    titleLeft =
      serieIndex === 0 ? '16.4444%' : serieIndex === 1 ? '49.6666%' : '83%';
  }
  return { left, titleLeft };
};

/**
 * 获取area折线图 面积渐变样式配置
 * @param seriesIndex echarts图series的索引
 * @returns 返回当前series的 渐变areaStyle
 */
export function generateGradientAreaStyleOfAreableLineChart(
  seriesIndex: number,
) {
  return {
    opacity: 0.3,
    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
      {
        offset: 0,
        color: ECHARTSCOLOR[seriesIndex],
      },
      {
        offset: 1,
        color: '#FFF',
      },
    ]),
  };
}

// 数值转为 K、M、B那种格式的数值
function kmbFormatter(params: any): string {
  return `${newMathFormat(Number(params.value), true)}`;
}
// 构建柱状图基础serie
export function generateBaseBarSerie(option: {
  index: number;
  name: string;
  cover: string;
  value: number;
  formatter?: (params: any) => string;
}) {
  const { index, name, cover, value, formatter: formatterOuter } = option || {};
  const formatter =
    typeof formatterOuter === 'function' ? formatterOuter : kmbFormatter;
  const color = ECHARTSCOLOR[index] || ECHARTSCOLOR[0];
  return {
    type: 'bar',
    name,
    value,
    cover,
    itemStyle: {
      color,
    },
    label: {
      show: true,
      position: 'top',
      color: '#444',
      distance: 4,
      fontSize: 12,
      formatter,
    },
  };
}

// 绝对保留指定位数小数
export function severalMathFormat(data, showZero, several = 2) {
  let unit = 'k';
  let value: any = Math.abs(data);
  if (showZero && !data) return (0).toFixed(2);
  if (!data || isNaN(data)) return '-';
  const isNegativeStr = data < 0 ? '-' : '';
  // 最外面的 parseFloat用于去除末尾无效的零
  if (value < 1000000 && value >= 1000) {
    unit = 'K';
    value = parseFloat(value / 1000).toFixed(several);
  } else if (value >= 1000000 && value < 1000000000) {
    unit = 'M';
    value = parseFloat(value / 1000000).toFixed(several);
  } else if (value >= 1000000000) {
    unit = 'B';
    value = parseFloat(value / 1000000000).toFixed(several);
  } else if (value < 1000) {
    unit = '';
    value = parseFloat(data).toFixed(several);
  }

  // Math.abs会去掉末尾的0，为保证数据格式统一，所以不用
  if (value < 0) value = -value;
  return isNegativeStr + value + unit;
}

export const handlePriceFormat = (value: any) => {
  if (value === null || value === '' || value === undefined) {
    return '-';
  }
  if (parseInt(value) === 0) {
    return 'Free';
  }
  return mathFormat(value, false, 0) || '';
};

export const valueFormatter = (
  value: number | string,
  metric: string,
): string => {
  if (['est_price', 'weighted_price'].includes(metric)) {
    return handlePriceFormat(value);
  }
  if (getIfPercentage(metric)) {
    return `${severalMathFormat(Number(value), true)}%`;
  }
  return severalMathFormat(value, true);
};

// fetch JSON data from a remote server using the provided URL
export const importJSON = (url: string) =>
  new Promise((resolve) => {
    const request = new XMLHttpRequest();
    request.open('get', url);
    request.send(null);
    request.onreadystatechange = () => {
      if (request.readyState == 4 && request.status == 200) {
        const json = JSON.parse(request.responseText);
        resolve(json || []);
      }
    };
  });

export const getRealValueOfSerie = (value: any): any => {
  // 折线点允许携带 tooltip 元数据；判定孤立点时必须继续取出内部 value，不能把外层对象当成数值。
  if (isObject(value)) return getRealValueOfSerie(value?.value);
  return Array.isArray(value) ? value[1] : value;
};

export interface ISpecialSeriesOption {
  emphasisOpacity?: number;
}

export const handleSerieSymbolConfig = (
  series: any[],
  getRealValue: (value: any) => any = getRealValueOfSerie,
  gameHighObj: any = {},
  specialSeriesOption?: ISpecialSeriesOption,
): any[] => {
  if (!Array.isArray(series)) return [];

  const isCustomValueGetter = typeof getRealValue === 'function';
  const emphasisOpacity = specialSeriesOption?.emphasisOpacity ?? 1;

  return series.map((serie) => {
    if (!serie) return serie;
    /** true 表示该曲线是可连线的真数点，需要保留全部显式 marker。 */
    const isConnectedTrueDataSeries = Boolean(serie?.dbIsTrueData);
    if (serie?.name) {
      // 是否是高亮折线图，是的话，正常显示圆点
      const isHighLine = serie?.name === gameHighObj?.name;

      // 找出这个轴每个点的数据
      const dataList: any[] = serie?.data || [];
      const itemDataOpt = [];
      for (let index = 0, len = dataList?.length; index < len; index++) {
        const dataItem = dataList?.[index];
        let currentDotValue = dataItem;
        let prevDotValue = dataList?.[index - 1];
        let nextDotValue = dataList?.[index + 1];
        if (isCustomValueGetter) {
          currentDotValue = getRealValue(currentDotValue);
          prevDotValue = getRealValue(prevDotValue);
          nextDotValue = getRealValue(nextDotValue);
        }
        const isCurrentDotEmpty = isEmpty(currentDotValue);
        const isPrevDotEmpty = isEmpty(prevDotValue);
        const isNextDotEmpty = isEmpty(nextDotValue);
        // 第一个点是孤立的
        const firstAlone = index === 0 && !isCurrentDotEmpty && isNextDotEmpty;
        // 中间的点是孤立的
        const betweenAlone =
          index !== 0 &&
          index !== len - 1 &&
          !isCurrentDotEmpty &&
          isNextDotEmpty &&
          isPrevDotEmpty;
        // 最后一个点是孤立的
        const lastAlone =
          index === len - 1 && !isCurrentDotEmpty && isPrevDotEmpty;
        // 圆点透明度
        const opacity =
          firstAlone || betweenAlone || lastAlone || isHighLine ? 1 : 0;
        const emphasisPoa = 1;
        // 当前data是否为Object类型
        const isObjectData = isObject(dataItem);
        // 重新组装后的data
        const dataItemTmp = merge(
          {
            ...(isObjectData ? dataItem : {}),
            name: serie?.name,
            itemStyle: {
              ...(isConnectedTrueDataSeries && isObjectData
                ? dataItem?.itemStyle
                : {}),
              // 真数点是稀疏但有效的观测值，不能套用普通折线的孤立点透明度规则。
              opacity: isConnectedTrueDataSeries ? 1 : opacity,
              emphasis: {
                ...(isConnectedTrueDataSeries && isObjectData
                  ? dataItem?.itemStyle?.emphasis
                  : {}),
                opacity: emphasisPoa,
              },
            },
            cover: serie?.cover,
          },
          {
            value: isObjectData ? dataItem?.value : dataItem,
          },
        );
        itemDataOpt.push(dataItemTmp);
      }
      serie.data = itemDataOpt;
    }
    serie.showSymbol = true;
    serie.showAllSymbol = true;
    // 仅连线真数保留调用方 marker；其他调用方继续沿用既有 circle 行为。
    serie.symbol = isConnectedTrueDataSeries
      ? serie.symbol || 'diamond'
      : 'circle';
    // hover的时候点出来
    serie.emphasis = merge(serie?.emphasis || {}, {
      itemStyle: {
        opacity: emphasisOpacity,
      },
    });

    return serie;
  });
};

export const handleSerieSymbolConfigByDataSet = (
  series: IEChartSeriesOption[],
  data: IEChartDataEntity[],
): IEChartSeriesOption[] => {
  if (!Array.isArray(series)) return [];

  return series.map((t) => {
    if (!t) return t;
    if (t?.name) {
      // 找出这个轴每个点的数据
      const itemValues: any[] = [];
      for (let index = 0; index < data?.length; index++) {
        const item = data?.[index];
        itemValues.push(item?.[t?.name]);
      }
      const itemDataOpt = [];
      for (let index = 0, len = itemValues?.length; index < len; index++) {
        const item = itemValues?.[index];
        const preItem = itemValues?.[index - 1];
        const nextItem = itemValues?.[index + 1];
        const isCurrentDotEmpty = isEmpty(item) || isNaN(item);
        const isPrevDotEmpty = isEmpty(preItem) || isNaN(preItem);
        const isNextDotEmpty = isEmpty(nextItem) || isNaN(nextItem);
        // 第一个点是孤立的
        const firstAlone = index === 0 && !isCurrentDotEmpty && isNextDotEmpty;
        // 中间的点是孤立的
        const betweenAlone =
          index !== 0 &&
          index !== len - 1 &&
          !isCurrentDotEmpty &&
          isNextDotEmpty &&
          isPrevDotEmpty;
        // 最后一个点是孤立的
        const lastAlone =
          index === len - 1 && !isCurrentDotEmpty && isPrevDotEmpty;
        // 孤立的点
        if (firstAlone || betweenAlone || lastAlone) {
          itemDataOpt.push({
            name: t?.name,
            value: item,
            itemStyle: {
              opacity: 1,
            },
          });
          // 连续的点
        } else {
          itemDataOpt.push({
            name: t?.name,
            value: item,
            itemStyle: {
              opacity: 0,
            },
          });
        }
      }
      t.showSymbol = true;
      t.showAllSymbol = true;
      t.symbol = 'circle';
      t.data = itemDataOpt;
    }
    // hover的时候点出来
    t.emphasis = {
      itemStyle: {
        opacity: 1,
      },
    };

    return t;
  });
};

const getKMBStr = (value: any, parser: (value: any) => number): string => {
  const numValue = parser(value);
  if (Number.isNaN(numValue)) return '-';
  return newMathFormat(numValue) as string;
};

const getPercentStr = (value: any, parser: (value: any) => number): string => {
  const percentValue = parser(value);
  if (Number.isNaN(percentValue)) return '-';
  return `${percentValue?.toFixed(2)}%`;
};

export const formatPieChartLabel = (params: any, isHigh = false): string => {
  const metricName = params?.name || '';
  const metricNameFormatted =
    metricName?.length > 12 ? `${metricName?.slice(0, 11)}...` : metricName;
  const metricValue = getKMBStr(params?.value, Number.parseFloat);
  const metricRatioValue = getPercentStr(params?.percent, Number.parseFloat);
  const metricValueAndMetricRatioValue = `${metricValue}(${metricRatioValue})`;
  return `{${isHigh ? 'contextbold' : 'context'
    }|${metricNameFormatted}: ${metricValueAndMetricRatioValue}}\n{hr|}\n{a|}`;
};

export const getPieChartLabelBaseRich = () => {
  return {
    per: {
      padding: [4, 0],
      align: 'left',
      opacity: 1,
    },
    context: {
      padding: [4, 0],
      align: 'left',
      opacity: 1,
    },
    hr: {
      width: '100%',
      height: 0,
      borderWidth: 2,
      borderColor: 'auto',
      opacity: 1,
    },
    a: {
      lineHeight: 20,
      align: 'center',
      color: 'transparent',
    },
  };
};
